interface IChartbeatParams {
  eventLabel: string
}

const chartbeatConversionEvent = (eventName: string, params: IChartbeatParams):void => {
  if(window === undefined) return
  const refferURL = new URLSearchParams(window?.location?.search)?.get('referrer_url')
  return (<any>window).chartbeat(eventName, {
    pathOverride: refferURL || 'https://www.estadao.com.br/',
    eventLabel: params.eventLabel
  })
}

export default chartbeatConversionEvent;